export const isExternalUrl = (url?: string): boolean => {
  return !url || /^(?:[a-z]+:)?\/\//i.test(url) || String(url).startsWith('mailto:');
};
